module.exports = __webpack_public_path__ + "static/basiseinkommen-53465ce981106e46827f6c777e2b4c5e.webm";